import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'showCharacters',
  standalone: false,
})
export class ShowCharactersPipe implements PipeTransform {
  transform(value: unknown, numToShow: number): string {
    if (value === null || value === undefined || numToShow < 0) {
      return value == null ? '' : String(value);
    }

    const stringValue = typeof value === 'string' ? value : String(value);

    const visibleCharacters = stringValue.substring(0, numToShow);
    const hiddenCharacters = '*'.repeat(Math.max(0, stringValue.length - numToShow));

    return visibleCharacters + hiddenCharacters;
  }
}
